"use client";

import React from "react";
import { ArrowUp } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const FALLBACK_COLUMNS = [{
  id: "col-missions",
  label: "MISSIONS",
  children: [{
    id: "sol-1",
    label: "Educational Quizzes",
    href: "#"
  }, {
    id: "sol-2",
    label: "Interest Modules",
    href: "#"
  }, {
    id: "sol-3",
    label: "Reward Protocol",
    href: "#"
  }]
}, {
  id: "col-protocol",
  label: "PROTOCOL",
  children: [{
    id: "age-1",
    label: "About V-IRAL",
    href: "#"
  }, {
    id: "age-2",
    label: "Neural Home",
    href: "/HomePage"
  }, {
    id: "age-3",
    label: "Join the Core",
    href: "#"
  }]
}, {
  id: "col-security",
  label: "SECURITY",
  children: [{
    id: "leg-1",
    label: "Privacy Vault",
    href: "#"
  }, {
    id: "leg-2",
    label: "Terms of Access",
    href: "#"
  }, {
    id: "leg-3",
    label: "Data Encryption",
    href: "#"
  }]
}, {
  id: "col-terminal",
  label: "TERMINAL",
  children: [{
    id: "soc-1",
    label: "X / Twitter",
    href: "#"
  }, {
    id: "soc-2",
    label: "Discord Server",
    href: "#"
  }, {
    id: "soc-3",
    label: "GitHub Repo",
    href: "#"
  }]
}];
function FooterLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="206321" className="w-full grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-4">
            <div className="h-6 w-24 bg-primary/10 rounded-none animate-pulse" />
            <div className="h-4 w-32 bg-primary/5 rounded-none animate-pulse" />
            <div className="h-4 w-28 bg-primary/5 rounded-none animate-pulse" />
          </div>)}
      </div>;
  }
  const displayItems = menuItems && menuItems.length > 0 ? menuItems : FALLBACK_COLUMNS;
  return <div className="w-full grid grid-cols-2 md:grid-cols-4 gap-8 mb-16 text-center md:text-left">
      {displayItems.map((col, i) => <div key={col.id} data-index={i} className="flex flex-col gap-4">
          <h4 className="font-default font-bold text-primary tracking-widest text-sm uppercase">
            {col.label}
          </h4>
          <div className="flex flex-col gap-3">
            {col.children?.map((link, j) => <div key={link.id} data-index={j}>
                <Link to={link.href === "/HomePage" ? "/HomePage" : link.href || "#"} className="font-mono text-[12px] text-muted-foreground hover:text-primary transition-colors duration-300 uppercase tracking-wider">
                  {link.label}
                </Link>
              </div>)}
          </div>
        </div>)}
    </div>;
}
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const currentYear = new Date().getFullYear();
  return;
}